import styled from 'styled-components';
import theme from 'common/theme'
export { labelWithColoredCirclesStyles } from 'common/ui/LabelWithColoredCircle/LabelWithColoredCircle.elements';
export const LabelWithCircleContainer = styled.button<{ color?: string, colorr?: string }>`
 
  background-color: transparent;
  padding: 0;
  font-family: inherit;
  font-weight: 400;
  border: none;
  width: max-content;
  text-transform: capitalize;
  font-size: 1em;
  cursor: pointer;
  padding-right: 1em;

  display: flex;
  flex-wrap: nowrap;
  gap: .3em;
  display: inline-flex;
  align-items: center;
  
  .value,
  .sub-text {
    font-size: .9em;
    color: ${theme.colors.label};
    font-weight: 800;
  }

 

    .color-circle,
    &:before {
      content: '';
      width: .8em;
      height: .8em;
      border-radius: 50%;
      background: ${({colorr, color}) => colorr || color || undefined};
    }
  
    &.is-not-selected {
 
      &:before {
        background: rgb(238, 238, 238);
      }
    }


  &.is-filtered {
    opacity: 0.7;
  }

  &.hovered {
    font-weight: 600;
 
  }
`;
